module.exports = __webpack_public_path__ + "media/images/mailer/logo_full-b352db921f9ffc23841da22643e91d6d.png";